import React, { Component, Fragment } from 'react';

import PropTypes from 'prop-types';
import ParadigmaModal from "../../../../components/ParadigmaModal/ParadigmaModal.js"

import api from "../../../../api/api";
import functions from '../../../../functions'
import { Button, Table, Alert } from 'reactstrap';
// import Detail from "../Detail.js"
import Detail from "../Modal.js"
import Ejecutores from './Ejecutores';
import Costos from './Costos.js';

class Imputar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imputacion_id: null,
      subtotal: '0,00', // a distribuir
      separaciones: [],

      codigoSolicitud: '',

      personal_id: null,
      personal_nombre: '',
      monto: '0',
      usuarioDistribucion_id: null,

      porcentajeFPLQ: 40,
      porcentajeEjecutores: 0,
      porcentajes: [],

      // labelAux: '',
      // porcentajeAux: 0,
      errors: {}
    };
    this.refModal = React.createRef();
  }

  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    id: PropTypes.func.isRequired,
  }

  setData = (data) => {
    if (data.allowed) {
      this.setState({
        imputacion_id: data.pk,
        subtotal: (data.monto - (data.monto * (data.porcentajeUVT / 100)) - data.insumosDirectos).toString().replace('.', ','),
        codigoSolicitud: data.solicitud_codigo,
        separaciones: data.separaciones.map((e) => { let aux = e; aux.monto = aux.monto.toString().replace('.', ','); return (aux) }),
        usuarioDistribucion_id: data.usuarioDistribucion_id,
        porcentajeFPLQ: data.porcentajeFPLQ,
        porcentajeEjecutores: data.porcentajeEjecutores,
        porcentajes: data.porcentajes,
        // labelAux: data.labelAux,
        // porcentajeAux: data.porcentajeAux,
      })
    }
  }
  

  resetState = () => {
    this.setState({
      imputacion_id: null,
      subtotal: '0,00', // a distribuir
      separaciones: [],

      codigoSolicitud: '',

      personal_id: null,
      personal_nombre: '',
      monto: '0',
      usuarioDistribucion_id: null,

      porcentajeFPLQ: 40,
      porcentajeEjecutores: 0,
      porcentajes: [],

      // labelAux: '',
      // porcentajeAux: 0,

      errors: {}
    })
  }

  AddToTable = () => {
    const { personal_id, personal_nombre, monto } = this.state;
    let separacionesaux = this.state.separaciones;
    if (personal_id != null && parseFloat(monto.replace(/[.]/g, '').replace(',', '.'))) {
      separacionesaux.push({ id: null, personal_id, personal_nombre, monto, nombre: '' });
      this.setState({
        separaciones: separacionesaux,
        personal_id: null,
        personal_nombre: '',
        monto: '0',
      })
    }
  }

  removeRow = (row) => {
    let separaciones = this.state.separaciones;
    separaciones.splice(row, 1);
    this.setState({
      separaciones: separaciones,
    });
  }


  reporte = (id) => {
    window.open(api.imputaciones.reportes.reportePDF + id + '/')
  }

  render() {
    const {
      subtotal, separaciones, codigoSolicitud,
      personal_id, usuarioDistribucion_id,
      personal_nombre, monto,
      porcentajeFPLQ, porcentajeEjecutores, porcentajes,
      // labelAux, porcentajeAux,
      errors
    } = this.state;
    const parsearAFloat = (m) => { return parseFloat(m.replace(/[.]/g, '').replace(',', '.')) };
    const redSubTotal = (accumulator, currentValue) => accumulator + parsearAFloat(currentValue.monto); //Reducer para calcular subtotal de montos en separaciones

    let permisos = (localStorage.permisos.includes('administrador') || (this.props.row() && this.props.row().imputar));

    return permisos && (
      <ParadigmaModal
        ref={_ref => { this.refModal = _ref }}
        getUrl={api.imputaciones.imputaciones.detail}
        postUrl={api.imputaciones.imputaciones.edit}
        onPreSubmit={() => { return { cerrada: true } }}
        buttonTitle={"Imputar"}
        title={"Imputar"}
        onGotErrors={(e) => this.setState({ errors: e })}
        onGotData={(data) => this.setData(data)}
        onClose={() => this.resetState()}
        onSubmit={() => this.props.onSubmit()}
        id={this.props.id}
        successMessage={"Imputar"}
        missingIdMessage={"Debe seleccionar una fila."}
        buttonIcon={"fa fa-edit fa-lg"}
        saveButton={false}
        saveButtonLabel={"Guardar"}
        closeButton={true}
        cancelButtonLabel={'Volver'}
        className={'ui-modal-dialog ui-modal-lg'}
      >
        <div className="ui-form">
        {(separaciones.length == 0) ?
          <section className="ui-section-block">
            <h3 className={'text-center'}>{'Debe distribuir la imputación previamente.'}</h3>
          </section>
          :
          (permisos == true ?
            <section className="ui-section-block">
                  <h5 className="ui-section-label">Distribuciones</h5>
                  <Table className="ui-table table-sm">
                    <thead>
                      <tr>
                        <th width='5%'></th>
                        <th width='15%'>Nombre</th>
                        <th width='25%'>Lider Técnico</th>
                        <th width='20%'>Importe ($)</th>
                        <th width='10%' className="text-center">Ver</th>
                        <th width='10%' className="text-center">Costos</th>
                        <th width='10%' className="text-center">Ejecutores</th>
                        <th width='10%' className="text-center">Reporte</th>
                      </tr>
                    </thead>
                    <tbody>
                      {separaciones.map((data, i) =>
                        <tr className="bg-light" key={`static${i}`}>
                          <td width='%'></td>
                          <td width='15%'>{data.nombre}</td>
                          <td width='25%'>{data.personal_nombre}</td>
                          <td width='20%' className={' text-right pr-3'}>{functions.formatCurrency(data.monto.toString().replace(",", "."))}</td>
                          <td width='10%' className="text-center">
                            <Detail
                              onClose={() => this.refModal && this.refModal.refreshState && this.refModal.refreshState()}
                              id={() => { return data.imputacion_id }}
                              action="DETAIL"
                            />
                          </td>
                          <td width='10%' className="text-center">
                            <Costos
                              onClose={() => this.refModal && this.refModal.refreshState && this.refModal.refreshState()}
                              id={() => { return data.id }}
                              porcentajeFPLQ={porcentajeFPLQ}
                              porcentajeEjecutores={porcentajeEjecutores}
                              porcentajes={porcentajes}
                            // labelAux={labelAux}
                            // porcentajeAux={porcentajeAux}
                            />
                          </td>
                          <td width='10%' className="text-center">
                            <Ejecutores
                              onClose={() => this.refModal && this.refModal.refreshState && this.refModal.refreshState()}
                              id={() => { return data.id }}
                              porcentajeFPLQ={porcentajeFPLQ}
                              porcentajeEjecutores={porcentajeEjecutores}
                              porcentajes={porcentajes}
                            />
                            </td>
                          <td width='10%' className="text-center">
                            <Button disabled={!data.finalizada} onClick={() => { if (data.finalizada == true) this.reporte(data.id) }} className={'icon btn btn-secondary btn-sm h-100'}> <i className={'fa fa-download fa-lg'} /></Button>
                          </td>
                        </tr>
                      )}
                    </tbody>
                    <tfoot>
                      <tr>
                        <th colSpan="3" className="col-1 text-right pr-4 font-weight-bold">Total ($)</th>
                        <th colSpan="1" className="col-1 text-right pr-3 font-weight-bold">
                          {functions.formatCurrency(separaciones.reduce(redSubTotal, 0))}
                        </th>
                      </tr>
                    </tfoot>
                  </Table>
            </section>
            :
            <section className="ui-section-block">
              <h3 className={'text-center'}>
                {'No tienes permisos para editar la imputación'}
              </h3>
            </section>)}
        <div className={'mt-2'}>
          {errors.cerrada &&
            <Alert color={'danger'} toggle={() => this.setState({ errors: {} })}>{errors.cerrada}</Alert>}
        </div>
        </div>
      </ParadigmaModal>
    );
  }
}

export default Imputar;



// WEBPACK FOOTER //
// ./src/views/Imputaciones/Imputaciones/ImputarModal/ImputarModal.js